import { render, staticRenderFns } from "./task-index.vue?vue&type=template&id=05c49244&scoped=true&"
import script from "./task-index.vue?vue&type=script&lang=js&"
export * from "./task-index.vue?vue&type=script&lang=js&"
import style0 from "./task-index.vue?vue&type=style&index=0&id=05c49244&lang=scss&scoped=true&"
import style1 from "./task-index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c49244",
  null
  
)

export default component.exports